import React from 'react';
import './loader.scss';
import PropTypes from 'prop-types';
import puzzleLoader from '../../Assets/images/svg/loading puzzle.gif';

// Setting text = "" makes it optional; if not passed, it defaults to an empty string
const Loader = ({ text = '' }) => {
  return (
    <div className="loader-container">
      <img src={puzzleLoader} alt="Loading..." className="puzzle-loader" />
      {/* Short-circuit evaluation: Only renders <p> if text is not empty */}
      {text && <p className="loader-label">{text}</p>}
    </div>
  );
};

Loader.propTypes = {
  text: PropTypes.string, // Optional string prop for loader text
};

export default Loader;
